export default __webpack_public_path__ + "static/media/leaflet-marker-yellow-selected.2c4e2de2.svg";